import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  user: null
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.user = action.payload
    },
    logout(state) {
      state.auth = null
      localStorage.removeItem("userToken")
    }
  }
})
export const { login, logout } = authSlice.actions
export default authSlice.reducer
